export enum FormActionTypes {
  SET_CURRENT_TAB = 'SET_CURRENT_TAB',
  LOAD_CONFIG = 'LOAD_CONFIG',
}
